import { render, staticRenderFns } from "./OrderReview.vue?vue&type=template&id=dcd4c148&scoped=true&"
import script from "./OrderReview.vue?vue&type=script&async=true&lang=js&"
export * from "./OrderReview.vue?vue&type=script&async=true&lang=js&"
import style0 from "./OrderReview.vue?vue&type=style&index=0&id=dcd4c148&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcd4c148",
  null
  
)

export default component.exports